import { StatusGanttVariantType } from "@components/index";
import { useStatusGantt } from "@src/common/hooks/useStatusGantt";

export function getEventStatusVariant(event: Sentinel.Timeline.Event): StatusGanttVariantType | null {
  if (!event.status) return null;

  const statusResponse = useStatusGantt(event.status);
  return statusResponse.variant || null;
}
